
import { defineComponent } from 'vue';
import { IExtension } from '@/types/models';
import utils from '@/utils';
import api from '@/api/my/plugins';
import Deploy from './components/plugins/Deploy.vue';
import Buy from './components/plugins/Buy.vue';

interface IState {
  activeName: string;
  extensions: IExtension[];
  orderResourceIds: string[];
  userName: string;
  isHostExists: boolean;
  extension: IExtension;
  isBuy: boolean;
  isDeploy: boolean;
}

export default defineComponent({
  components: {
    Deploy,
    Buy,
  },
  data() {
    return {
      activeName: 'my',
      extensions: [],
      orderResourceIds: [],
      userName: '',
      isHostExists: false,
      extension: {} as IExtension,
      isBuy: false,
      isDeploy: false,
    } as IState;
  },
  methods: {
    apiGet() {
      api.get({ type: this.activeName }, (res) => {
        this.extensions = res.extensions;
        this.orderResourceIds = res.orderResourceIds;
        this.userName = res.userName;
        this.isHostExists = res.isHostExists;
      });
    },

    apiDelete(extension: IExtension) {
      api.delete(
        {
          name: extension.name,
        },
        (res) => {
          if (!res) return;
          utils.success('插件删除成功！');
          this.apiGet();
        },
      );
    },

    getUrl(relatedUrl: string) {
      return `https://sscms.com/extensions/${relatedUrl}`;
    },

    getDownloadUrl(extension: IExtension) {
      return `https://dl.sscms.com/extensions/${extension.userName}/T_${extension.name}.zip`;
    },

    isAuthenticated(extension: IExtension) {
      if (extension.price > 0 && extension.userName !== this.userName) {
        return this.orderResourceIds.indexOf(extension.guid) !== -1;
      }
      return true;
    },

    btnTabsClick() {
      this.apiGet();
    },

    btnBuyClick(extension: IExtension) {
      this.extension = extension;
      this.isBuy = true;
    },

    btnDeployClick(extension: IExtension) {
      this.isDeploy = true;
      this.extension = extension;
    },

    btnDownloadClick(extension: IExtension) {
      api.getExtension(
        {
          userName: extension.userName,
          name: extension.name,
        },
        (res) => {
          if (!res) return;
          window.open(res.extensionDownloadUrl);
        },
      );
    },

    btnDeleteClick(extension: IExtension) {
      utils.alertDelete(
        {
          title: '删除插件',
          text: `此操作将删除插件 ${extension.name}，确定吗？`,
          button: '确认删除',
        },
        () => {
          this.apiDelete(extension);
        },
      );
    },

    btnBuyCloseClick() {
      this.isBuy = false;
      this.apiGet();
    },
  },
  mounted() {
    this.apiGet();
  },
});
